__turbopack_context__.v({
  "icon": "RbyeNa_icon",
  "input": "RbyeNa_input",
  "searchBar": "RbyeNa_searchBar",
  "shortcut": "RbyeNa_shortcut",
});
